import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  untracked,
} from '@angular/core';
import {
  ConsentType,
  getIsConsentSetLoading,
  getLegalTexts,
  getMissingConsents,
  RequestLogout,
  SetConsentV2,
} from '@resident-nx/shared';
import { Store } from '@ngrx/store';
import { ConsentAgbWebComponent } from './consent-agb/consent-agb.component';
import { ConsentPrivacyWebComponent } from './consent-privacy/consent-privacy.component';
import { ConsentDocumentsWebComponent } from './consent-documets/consent-documents.component';
import { Router } from '@angular/router';

@Component({
  selector: 'rs-web-consent',
  templateUrl: './consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConsentAgbWebComponent, ConsentPrivacyWebComponent, ConsentDocumentsWebComponent],
})
export class ConsentWebComponent {
  protected readonly ConsentType = ConsentType;

  readonly #store = inject(Store);
  readonly #router = inject(Router);
  readonly legalTexts = this.#store.selectSignal(getLegalTexts);
  readonly missingConsents = this.#store.selectSignal(getMissingConsents);
  readonly isConsentSetLoading = this.#store.selectSignal(getIsConsentSetLoading);
  readonly activeConsent = computed(() => this.missingConsents()[0]?.type);

  constructor() {
    effect(() => {
      const activeConsent = this.activeConsent();

      untracked(() => {
        if (!activeConsent) {
          void this.#router.navigate(['dashboard']);
        }
      });
    });
  }

  acceptConsent(consent: { legalTextId: string; consentGiven: boolean }) {
    this.#store.dispatch(SetConsentV2(consent));
  }

  declineConsent() {
    this.#store.dispatch(RequestLogout({}));
  }
}
